import React from 'react';
import PropTypes from 'prop-types';
import Box from '4all-ui/components/Box';
import OrderItem from './OrderItem';
import OrderStatusLabel from '../../OrderStatusLabel';
import NotFoundIcon from '../../Icons/NotFound';
import * as styles from './style';
import AlertIcon from '../../Icons/Alert';

const SearchResultsBox = ({
  searchStatus,
  selectOrder,
  idOrderSelected,
  ordersIsFetching,
  orders,
  renderPlaceholder,
  ordersError,
}) => {
  const renderContent = () => {
    if (ordersIsFetching) {
      return renderPlaceholder();
    }

    if (ordersError) {
      return (
        <styles.EmptyContainer className="orders-empty">
          <styles.Icon>
            <AlertIcon size="40px" />
          </styles.Icon>

          <styles.EmptyContainerText error={!!ordersError}>{ordersError}</styles.EmptyContainerText>
        </styles.EmptyContainer>
      );
    }

    if (!orders.length) {
      return (
        <styles.EmptyContainer className="orders-empty">
          <styles.Icon>
            <NotFoundIcon />
          </styles.Icon>

          <styles.EmptyContainerText>Nenhum resultado encontrado</styles.EmptyContainerText>
        </styles.EmptyContainer>
      );
    }

    if (orders.length) {
      return orders.map(item => (
        <OrderItem
          key={item.id}
          selected={item.id === idOrderSelected}
          order={item}
          selectOrder={selectOrder}
        />
      ));
    }
  };

  return (
    <Box
      colSize={4}
      customStyles={{
        minHeight: 'auto',
        overflow: 'hidden',
      }}
    >
      {!ordersIsFetching ? (
        <OrderStatusLabel orders={orders.length} searchStatus={searchStatus} />
      ) : null}

      <styles.OrderListContainer className="order-item-wrapper">
        {renderContent()}
      </styles.OrderListContainer>
    </Box>
  );
};

SearchResultsBox.propTypes = {
  searchStatus: PropTypes.object,
  selectOrder: PropTypes.func.isRequired,
  idOrderSelected: PropTypes.number,
  ordersIsFetching: PropTypes.bool,
  orders: PropTypes.array,
  renderPlaceholder: PropTypes.func,
  ordersError: PropTypes.any,
};

SearchResultsBox.defaultProps = {
  searchStatus: {},
  idOrderSelected: null,
  ordersIsFetching: false,
  orders: [],
  renderPlaceholder: null,
  ordersError: null,
};

export default SearchResultsBox;



// WEBPACK FOOTER //
// ./src/components/OrderList/SearchResultsBox/index.js